import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentTool } from '@/shared/hooks/useCurrentTool'
import Button from '@/shared/components/AppButton'
import { GradientBorder } from '@/shared/components/GradientBorder'
import Loader from '@/shared/components/Loader';

const ProcessingState = ({ uploading, generating, onReset }) => {
  const { t } = useTranslation();
  const { generation_name } = useCurrentTool();

  return (
    <div className='flex flex-col h-[97dvh] md:h-fit justify-center items-center'>
      <GradientBorder>
        <div className="shadow-sm bg-white rounded-full px-4 py-4">
          <Loader />
        </div>
      </GradientBorder>
      
      {uploading && (
        <div className='flex flex-col items-center w-full'>
          <h1 className='font-medium mt-[16px] md:text-[24px] text-xl'>
            {t('reports.generate.uploading')}
          </h1>
          <p className='sm:w-[320px] max-w-[320px] text-[#505050] mt-[4px] font-SuisseIntlLight font-medium text-[16px]'>
            {t('reports.generate.pleaseWait')}
          </p>
          <Button variant='disabled' className='mt-[16px] max-w-fit cursor-not-allowed' onClick={() => {}}>
            {t('reports.generate.new', { type: generation_name })}
          </Button>
        </div>
      )}
      
      {generating && (
        <div className='flex flex-col items-center w-full'>
          <h1 className='font-medium mt-[16px] md:text-[24px] text-xl'>
            {t('reports.generate.generating')}
          </h1>
          <p className='sm:w-[320px] max-w-[320px] text-[#505050] mt-[4px] font-SuisseIntlLight font-normal text-[16px]'>
            {t('reports.generate.waitMinutes')}
          </p>
          <Button variant='light' className='mt-[16px] max-w-fit' onClick={onReset}>
            {t('reports.generate.new', { type: generation_name })}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProcessingState;